import { Autocomplete, Avatar, Box, Button, Checkbox, Chip, CircularProgress, Grid, IconButton, Input, Menu, MenuItem, Pagination, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { Fragment, useEffect, useState } from "react";
import { ITableHeader } from "src/_shares/_components/data-table/data-table";
import OmsService from "src/_cores/_services/oms.service";
import { ORDER_STATUSES, ORDER_STATUS_CODE } from "src/_cores/_constants/order-constants";
import { IOrderPagedRequest } from "../../interfaces/oms-interface";
import { api } from "src/_cores/_api/api";
import { IUserGetParam } from "../../interfaces/user-interface";
import UserService from "src/_cores/_services/user.service";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

import dayjs, { Dayjs } from 'dayjs';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import OrderItem from "./order-item";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const header: ITableHeader[] = [
    { field: 'orderCode', fieldName: 'Mã đơn hàng', align: 'left' },
    { field: 'createdDate', fieldName: 'Ngày tạo', align: 'left' },
    { field: 'createdBy', fieldName: 'Người tạo', align: 'left' },
    { field: 'totalPrice', fieldName: 'Tạm tính', align: 'left' },
    { field: 'totalPriceOnSell', fieldName: 'Tạm tính đã giảm', align: 'left' },
    { field: 'totalDiscount', fieldName: 'Giảm giá từ voucher', align: 'left' },
    { field: 'totalFinalPrice', fieldName: 'Thành tiền', align: 'left' },
    { field: 'paymentMethod', fieldName: 'Phương thức thanh toán', align: 'left' },
    { field: 'status', fieldName: 'Trạng thái', align: 'left' },
    { field: 'action', fieldName: '', align: 'center' }
];

export default function OrderList() {
    const [open, setOpen] = useState(false);
    const [filterUsers, setFilterUsers] = useState<any[]>([]);
    const [users, setUsers] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [orders, setOrders] = useState<any[]>([]);
    const [selectedOrders, setSelectedOrder] = useState<number[]>([]);
    const [totalPages, setTotalPages] = useState<number>(1);
    const [params, setParams] = useState<IOrderPagedRequest>({
        pageIndex: 1,
        pageSize: 10,
        searchKey: '',
        voucher: '',
        status: ORDER_STATUS_CODE.ORDER_PENDING,
        phoneNumber: '',
        fromDate: null,
        toDate: null,
    });

    useEffect(() => {
        getUsers();
        search(params);
    }, []);

    async function getUsers() {
        const params = {
            pageIndex: 1,
            pageSize: 1000,
        } as IUserGetParam
        const res = await UserService.getUserList(params) as any;
        if (res?.isSucceed) {
            setUsers(res.data.items);
        }
    }

    const search = async (_params: IOrderPagedRequest) => {
        setLoading(true);
        const response = await OmsService.getOrdersPaging(_params) as any;
        if (response?.isSucceed) {
            setOrders(response.data?.items);
            setTotalPages(response.data?.totalPages);
            setLoading(false);
        }
    }

    const approve = async (id: string) => {
        const response = await api.post("/order/approve-order" + `/${id}`, {}) as any;
        if (response?.isSucceed) {
            search(params);
        }
    }

    const reject = async (id: string) => {
        const response = await api.post("/order/reject-order" + `/${id}`, {}) as any;
        if (response?.isSucceed) {
            search(params);
        }
    }

    const onChangeStatus = async (status?: string) => {
        const _params = { ...params, status: status || '' };
        setParams(_params);
        search(_params);
    }

    const pageChange = (event: any, pageIndex: number) => {
        const _params = { ...params, pageIndex: pageIndex || 1 };
        setParams(_params);
        search(_params);
    }

    const onChangeInput = (type: 'searchKey' | 'voucher' | 'phoneNumber', event: any) => {
        const _params = { ...params, [type]: event?.target?.value || '' };
        setParams(_params);
    }

    const onChangeDate = (type: 'fromDate' | 'toDate', date: Dayjs | null) => {
        const _params = {
            ...params,
            [type]: date
                ? new Date(Date.UTC(
                    date.year(),
                    date.month(),
                    date.date(),
                    0, 0, 0, 0
                ))
                : null
        };
        setParams(_params);
    }

    const temp = async (id: number, stat = 0) => {
    }


    const onChangeFilterUsers = (items: any[]) => {
        const _userNames = items.map(_ => _.userName) as any;
        setFilterUsers(_userNames);
        const _params = { ...params, userNames: _userNames || [] };
        setParams(_params);
        search(_params);
    }

    return (
        <Fragment>
            <Box>
                <Grid container spacing={2} sx={{ marginBottom: 2 }}>
                    <Grid item xs={12} sm={2}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Từ ngày tạo"
                                value={params.fromDate ? dayjs(params.fromDate) : null}
                                onChange={(newValue) => onChangeDate('fromDate', newValue)}
                                format="DD/MM/YYYY"
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Đến ngày tạo"
                                value={params.toDate ? dayjs(params.toDate) : null}
                                onChange={(newValue) => onChangeDate('toDate', newValue)}
                                format="DD/MM/YYYY"
                            />
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Autocomplete
                            size="small"
                            disablePortal
                            value={ORDER_STATUSES.find(_ => _.code === params.status) ?? null}
                            options={ORDER_STATUSES}
                            renderInput={(params) => <TextField {...params} name="status" label="Trạng thái đơn hàng" />}
                            getOptionLabel={(option: any) => option.name}
                            onChange={(event, value) => onChangeStatus(value?.code)}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Autocomplete
                            multiple
                            id="checkboxes-tags-demo"
                            options={users}
                            disableCloseOnSelect
                            getOptionLabel={(item: any) => `${item.userId} - ${item.userFullName}`}
                            value={
                                users.length > 0 && filterUsers
                                    ? users.filter((item: any) => filterUsers.some((_: any) => _ === item.userName))
                                    : []
                            }
                            renderOption={(props, item: any, { selected }) => (
                                <li {...props}>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                        size="small"
                                    />
                                    {item.userId} - {item.userFullName}
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextField {...params} label="Người dùng" placeholder="Chọn người dùng" size="small" />
                            )}
                            onChange={(event, items: any) => onChangeFilterUsers(items)}
                            size="small"
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField className="w-full" label="Mã giảm giá" placeholder="Nhập để tìm" size="small" onChange={(event: any) => onChangeInput('voucher', event)} />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField className="w-full" label="Số điện thoại" placeholder="Nhập để tìm" size="small" onChange={(event: any) => onChangeInput('phoneNumber', event)} />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField className="w-full" label="Tìm kiếm" placeholder="Nhập để tìm" size="small" onChange={(event: any) => onChangeInput('searchKey', event)} />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Button variant="contained" onClick={() => search(params)}>
                            Xem
                        </Button>
                    </Grid>
                </Grid>
            </Box>
            <TableContainer component={Paper} sx={{ marginBottom: 2 }}>
                <Table aria-label="collapsible table">
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <Checkbox
                                    sx={{ display: 'none' }}
                                />
                            </TableCell>
                            {header.map((field) => (
                                <TableCell key={field.field} align={!field.align ? 'left' : field.align}>{field.fieldName}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    {loading
                        ? <CircularProgress />
                        : <TableBody>
                            {orders.length > 0 && orders.map((item, idx) => (
                                <OrderItem
                                    key={`row-${item.id}`}
                                    rowData={item}
                                    isSelected={selectedOrders.includes(item.id)}
                                    onUpdateStatus={(id, status) => temp(id, status)}
                                    onDelete={(id) => temp(id)}
                                    onApprove={(id) => approve(id)}
                                    onReject={(id) => reject(id)}
                                    onSelected={(id) => temp(id)}
                                    onViewDetail={(id) => temp(id)}
                                />
                            ))}
                        </TableBody>}
                </Table>
            </TableContainer>
            <Pagination
                variant="outlined"
                shape="rounded"
                page={params.pageIndex}
                count={totalPages}
                onChange={pageChange}
            />
        </Fragment>
    )
}